var Highcharts = require('highcharts');
// Load module after Highcharts is loaded
//require('highcharts/modules/exporting')(Highcharts);

import { baseAPIUrl, httpPostHandleResponse, getHtml_HandleBar, GetDateRangePickerDateObject, baseWebUrl, sweetAlert, AlertType, AlertTitle, formatDate_MMMYYYY, formatDate_MMMDDYYYY, getFirstAndLastDate, bindDateRangePicker, bindFlatpickrRange, formatDate_MMMDDYYYYHHMMSS, formatDate_HHMMSS, formatDate_HHMM, bindBootstrapDatePicker, bindFlatpickr, formatDate_DDMMYYYY, secondsToHHMM, isNullOrEmpty } from "../utils/common"
import { Loader } from "../services/loaderService";
import http, { GetToken } from "../services/httpService";
import moment = require("moment");

declare var KTUtil: any;
declare var KTApp: any;
declare var Chart: any;
declare var lucide: any;
class Contants {
    readonly controller: string = baseAPIUrl() ? `${baseAPIUrl()}/Dashboard` : '/Dashboard';
    readonly controllerDocumentType: string = baseAPIUrl() ? `${baseAPIUrl()}/DocumentType` : '/DocumentType';
    readonly employeeController: string = baseAPIUrl() ? `${baseAPIUrl()}/Employee` : '/Employee';
    readonly leaveController: string = baseAPIUrl() ? `${baseAPIUrl()}/Leave` : '/Leave';
    readonly resignController: string = baseAPIUrl() ? `${baseAPIUrl()}/Resign` : '/Resign';
    readonly attendenceController: string = baseAPIUrl() ? `${baseAPIUrl()}/Attendence` : '/Attendence';
    readonly totalProducts: string = '#totalProducts';
    readonly totalItems: string = '#totalItems';
    readonly totalCategories: string = '#totalCategories';
    readonly totalUsers: string = '#totalUsers';

    readonly tmplActivity: string = '#tmpl_Activity';
    readonly divActivityContainer: string = '#divActivityContainer';

    readonly gridDetails: string = "#kt_Grid_Details";
    readonly kt_Dashboard_Modal: string = "#kt_Dashboard_Modal";

    readonly gridDetailsHeader: string = "#gridHeader";
    readonly gridHeaderTemplate: string = '#gridHeaderTemplate';

    readonly dtpStartDate: string = "#dtpStartDate";
    readonly dtpStartDate_2: string = "#dtpStartDate_2";
}

class Dashboard {
    loader: Loader = new Loader();
    constants: Contants = new Contants();

    EmployeeUpdateInfoRequestData: any = [];

    drillBreadCrumb: any = [];

    $totalProducts: JQuery<HTMLElement>;
    $totalItems: JQuery<HTMLElement>;
    $totalCategories: JQuery<HTMLElement>;
    $totalUsers: JQuery<HTMLElement>;
    $divActivityContainer: JQuery<HTMLElement>;
    $grid: DataTables.Api;
    $kt_Dashboard_Modal: JQuery<HTMLElement>;

    $gridHeader: JQuery<HTMLElement>;

    userData: any;

    constructor() {

        this.Init();
        this.reInitializeAllCharts();

        this.setupThemeObserver();
    }

    private Init = async () => {
        this.loader.showLoader();

        this.bindEvents();
        this.checkMissingMandatoryDocument();
        this.userData = JSON.parse(localStorage.getItem('UserData'));

        if (this.userData.UserType != 27) {
            this.GenerateAttendanceDailyData();
            this.GenerateAttendanceSummaryData();
            this.GenerateEmployeePerformance();
            this.GenerateLeaveQuota();
        }

        this.GenerateEvent();

        let ExpiredCNICCount = this.userData.Permissions.indexOf('ExpiredCNICCount_Chart');
        if (ExpiredCNICCount != -1) {
            this.LoadCNICExpiryCount();
        }

        let ClientContractExpiryCount = this.userData.Permissions.indexOf('ClientContractExpiry_Chart');
        if (ClientContractExpiryCount != -1) {
            this.LoadClientExpiryCount();
        }

        let employeeInfoUpdateRequest = this.userData.Permissions.indexOf('View_EmployeeInfoUpdateRequest_Chart');
        if (employeeInfoUpdateRequest != -1) {
            this.LoadEmployeeInfoUpdateRequestCount();
        }

        let View_MissingDocumentChart = this.userData.Permissions.indexOf('View_MissingDocumentChart');
        if (View_MissingDocumentChart != -1) {
            this.LoadMissingDocumentCount();
        }

        let NewHires = this.userData.Permissions.indexOf('NewHires_Chart');
        if (NewHires != -1) {
            this.loadNewHires();
        }

        let Active_Employee = this.userData.Permissions.indexOf('Active_Employee_Chart');
        if (Active_Employee != -1) {
            this.loadActiveEmployees();
        }

        let Resign = this.userData.Permissions.indexOf('Resign_Chart');
        if (Resign != -1) {
            this.loadResignEmployees();
        }

        let SixtyYearEmployees = this.userData.Permissions.indexOf('Employees60YearsOld_Chart');
        if (SixtyYearEmployees != -1) {
            this.Load60YearCount();
        }

        let LeaveRequest = this.userData.Permissions.indexOf('LeaveRequest_Chart');
        if (LeaveRequest != -1) {
            this.loadLeaveRequest();
        }

        let ResignRequest = this.userData.Permissions.indexOf('ResignRequest_Chart');
        if (ResignRequest != -1) {
            this.loadResignRequest();
        }

        let AbsenceWithoutLeave = this.userData.Permissions.indexOf('AbsenceWithoutLeave_Chart');
        if (AbsenceWithoutLeave != -1) {
            this.LoadWithoutLeaveAbsence();
        }

        if (this.userData.UserType == 27) {
            $('#cont_dashboard_basicprofile').addClass('d-none');
        } else {
            this.GenerateBasicInfo(this.userData);
        }

        let employerGraphPermissions = [
            'ExpiredCNICCount_Chart',
            'ClientContractExpiry_Chart',
            'View_EmployeeInfoUpdateRequest_Chart',
            'View_MissingDocumentChart',
            'NewHires_Chart',
            'Active_Employee_Chart',
            'Resign_Chart',
            'Employees60YearsOld_Chart',
            'LeaveRequest_Chart',
            'ResignRequest_Chart',
            'AbsenceWithoutLeave_Chart'
        ];

        const hasEmployerGraphs = employerGraphPermissions.some(p => this.userData.Permissions.indexOf(p) !== -1);

        if (!hasEmployerGraphs) {
            $('#employerTabNavItem').hide();
        } else {
            $('#employerTabNavItem').show();
        }
        this.loader.hideLoader();
    }

    private getHighchartsThemeOptions = (isDarkMode?: boolean) => {
        return {
            colors: [
                '#2b908f',
                '#90ee7e',
                '#f45b5b',
                '#7798BF',
                '#aaeeee',
                '#ff0066',
                '#eeaaee'
            ],

            chart: {
                backgroundColor: 'transparent',        
                plotBackgroundColor: 'transparent',    
                plotBorderWidth: 0,
                style: {
                    fontFamily: 'Roboto'
                }
            },

            legend: {
                backgroundColor: 'transparent'
            },

            tooltip: {
                backgroundColor: 'rgba(0,0,0,0.7)' 
            }
        };
    };


    private updateAllChartsTheme = () => {
        const themeOptions = this.getHighchartsThemeOptions();

        Highcharts.setOptions(themeOptions);

        Highcharts.charts.forEach((chart: any) => {
            if (chart) {
                chart.update(themeOptions, true);
            }
        });
    };


    private setupThemeObserver = () => {
        const observer = new MutationObserver(() => {
            this.updateAllChartsTheme(); 
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });
    };

   
    private reInitializeAllCharts = () => {
        const isDarkMode = $('html').attr('data-theme') === 'dark';
        const themeOptions = this.getHighchartsThemeOptions(isDarkMode);
        Highcharts.setOptions(themeOptions);

        Highcharts.charts.forEach((chart: any) => {
            if (chart) {
                chart.destroy();
            }
        });

        if (this.userData.UserType != 27) {
            this.GenerateAttendanceDailyData();
            this.GenerateAttendanceSummaryData();
            this.GenerateEmployeePerformance(); // Chart function
            this.GenerateLeaveQuota(); // Chart function
        }
        this.GenerateEvent();

        let ExpiredCNICCount = this.userData.Permissions.indexOf('ExpiredCNICCount_Chart');
        if (ExpiredCNICCount != -1) {
            this.LoadCNICExpiryCount();
        }

        let ClientContractExpiryCount = this.userData.Permissions.indexOf('ClientContractExpiry_Chart');
        if (ClientContractExpiryCount != -1) {
            this.LoadClientExpiryCount();
        }

        let employeeInfoUpdateRequest = this.userData.Permissions.indexOf('View_EmployeeInfoUpdateRequest_Chart');
        if (employeeInfoUpdateRequest != -1) {
            this.LoadEmployeeInfoUpdateRequestCount();
        }

        let View_MissingDocumentChart = this.userData.Permissions.indexOf('View_MissingDocumentChart');
        if (View_MissingDocumentChart != -1) {
            this.LoadMissingDocumentCount();
        }

        let NewHires = this.userData.Permissions.indexOf('NewHires_Chart');
        if (NewHires != -1) {
            this.loadNewHires();
        }

        let Active_Employee = this.userData.Permissions.indexOf('Active_Employee_Chart');
        if (Active_Employee != -1) {
            this.loadActiveEmployees();
        }

        let Resign = this.userData.Permissions.indexOf('Resign_Chart');
        if (Resign != -1) {
            this.loadResignEmployees();
        }

        let SixtyYearEmployees = this.userData.Permissions.indexOf('Employees60YearsOld_Chart');
        if (SixtyYearEmployees != -1) {
            this.Load60YearCount();
        }

        let LeaveRequest = this.userData.Permissions.indexOf('LeaveRequest_Chart');
        if (LeaveRequest != -1) {
            this.loadLeaveRequest();
        }

        let ResignRequest = this.userData.Permissions.indexOf('ResignRequest_Chart');
        if (ResignRequest != -1) {
            this.loadResignRequest();
        }

        let AbsenceWithoutLeave = this.userData.Permissions.indexOf('AbsenceWithoutLeave_Chart');
        if (AbsenceWithoutLeave != -1) {
            this.LoadWithoutLeaveAbsence();
        }
    }
   
    private GenerateAttendanceDailyData = async () => {
        this.loader.showLoader();

        if (this.userData == undefined || this.userData.Id == undefined) {
            return false;
        }

        let request: any = {
            StartDate: $(this.constants.dtpStartDate).val(),
            EndDate: $(this.constants.dtpStartDate).val(),
            EmpIds: this.userData.Id
        };

        const response = await http.post(this.constants.attendenceController + "/AttendenceReportData", request);
        const data = httpPostHandleResponse(response);

        if (data.length > 0) {

            const dataObject = data[0];

            $('#dashboard_status').text(dataObject.AttStatus);
            $('#dashboard_CheckIn').text((dataObject.In == null ? '-' : formatDate_HHMMSS(dataObject.In)));
            $('#dashboard_LateIn').text((dataObject.Late ? new Date(dataObject.LateInHrs * 1000).toISOString().substring(11, 16) : '-'));
            $('#dashboard_CheckOut').text((dataObject.Out == null ? '-' : formatDate_HHMMSS(dataObject.Out)));
            $('#dashboard_EarlyOut').text((dataObject.Early ? new Date((isNullOrEmpty(dataObject.EarlyOutHrs) ? 0 : dataObject.EarlyOutHrs) * 1000).toISOString().substring(11, 16) : '-'));
            $('#dashboard_OverTime').text((dataObject.DailyOT > 0 ? new Date(dataObject.DailyOT * 1000).toISOString().substring(11, 16) : '-'));
            $('#dashboard_Shift').text(dataObject.ShiftName);

            let sourceIn = '-'
                , sourceOut = '-';

            if (dataObject.InSource == 'Machine') {
                sourceIn = 'MCH';
            }
            else if (dataObject.InSource == 'Manual') {
                sourceIn = 'MNL';
            }
            else if (dataObject.InSource == 'Mobile') {
                sourceIn = 'MOB';
            }

            if (dataObject.OutSource == 'Machine') {
                sourceOut = 'MCH';
            }
            else if (dataObject.OutSource == 'Manual') {
                sourceOut = 'MNL';
            }
            else if (dataObject.OutSource == 'Mobile') {
                sourceOut = 'MOB';
            }

            $('#dashboard_SourceInOut').text(sourceIn + ' / ' + sourceOut);

            $('#cont_dashboard_AttendanceDaily').removeClass('d-none');
        }
        this.loader.hideLoader();
    }

    private secondsTohh(seconds: any) {
        return (seconds / 3600);
    }

    private GenerateEmployeePerformance = async () => {
        const isDarkMode = $('html').attr('data-theme') === 'dark';
        Highcharts.setOptions(this.getHighchartsThemeOptions(isDarkMode));
        let request: any = {
            StartDate: moment().subtract(29, 'days'),
            EndDate: moment(),
            EmpIds: this.userData.Id
        };

        const response = await http.post(this.constants.attendenceController + "/AttendenceReportData", request);
        const data = httpPostHandleResponse(response);

        let dataReqHrs: any = [], dataWorkHrs: any = [], dataOverTime: any = [], dates: any = {}, maxYaxis = 0;

        for (let i = 0; i < data.length; i++) {

            const date = 'd' + formatDate_DDMMYYYY(data[i].Month);

            dataReqHrs.push([date, this.secondsTohh(data[i].ReqDutyHrs)]);
            dataWorkHrs.push([date, this.secondsTohh(data[i].WHrs)]);
            dataOverTime.push([date, this.secondsTohh(data[i].DailyOT)]);

            if (maxYaxis < this.secondsTohh(data[i].WHrs)) {
                maxYaxis = this.secondsTohh(data[i].WHrs);
            }

            if (maxYaxis < this.secondsTohh(data[i].ReqDutyHrs)) {
                maxYaxis = this.secondsTohh(data[i].ReqDutyHrs);
            }

            if (maxYaxis < this.secondsTohh(data[i].DailyOT)) {
                maxYaxis = this.secondsTohh(data[i].DailyOT);
            }

            dates[date] = {
                name: formatDate_MMMDDYYYY(data[i].Month)
            };
        }

        $('#cont_dashboard_EmployeePerformance').removeClass('d-none');

        Highcharts.chart('chart_EmployeePerformance', {
            chart: {
                type: 'column'
            },
            dates,
            title: false,
            subtitle: false,
            plotOptions: {
                series: {
                    grouping: false,
                    borderWidth: 0
                }
            },
            legend: {
                enabled: true
            },
            tooltip: {
                shared: true,
                headerFormat: '',
                pointFormatter: function () {
                    const point = this;

                    const value = secondsToHHMM(point.y * 3600);
                    return '<span style="font-size: 15px" > ' + dates[point.options.name].name + ' </span><br/ > ' + '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + value + '</b><br/>'
                }
            },
            xAxis: {
                type: 'category',
                labels: {
                    useHTML: true,
                    animate: true,
                    formatter: function () {
                        let _that = this;

                        return dates[_that.value].name;
                    },
                    style: {
                        textAlign: 'center',
                        color: '#000000'
                    }
                }
            },
            yAxis: [{
                title: false,
                max: maxYaxis,
                showFirstLabel: false
            }],
            series: [{
                color: 'rgba(158, 159, 163, 0.5)',
                pointPlacement: -0.2,
                data: dataReqHrs.slice(),
                name: 'Req. Hrs'
            }, {
                color: '#ff7b7b',
                name: 'Work Hrs',
                id: 'main',
                data: dataWorkHrs.slice()
            },
            {
                color: '#BBE3FF',
                pointPlacement: 0.2,
                data: dataOverTime.slice(),
                name: 'OT Hrs'
            }],
            exporting: {
                allowHTML: true
            }
        });
    }

    private GenerateAttendanceSummaryData = async () => {
        this.loader.showLoader();
        if (!this.userData?.Id) {
            this.loader.hideLoader();
            return;
        }
        const dtObject = GetDateRangePickerDateObject(this.constants.dtpStartDate_2);

        let request: any = {
            StartDate: dtObject.firstDay,
            EndDate: dtObject.lastDay,
            EmpIds: this.userData.Id
        };

        const response = await http.post(this.constants.attendenceController + "/AttendenceReportData", request);
        const data = httpPostHandleResponse(response);

        let workDays = 0,
            presentDays = 0,
            absentDays = 0,
            ghDays = 0,
            halfDays = '-',
            reqHrs = 0,
            workHrs = 0,
            overtime = 0;

        for (let i = 0; i < data.length; i++) {
            if (data[i].WorkDays) {
                workDays += 1;
            }
            if (data[i].PresentDays) {
                presentDays += 1;
            }
            if (data[i].AbsentDays) {
                absentDays += 1;
            }
            if (data[i].GazettedDays) {
                ghDays += 1;
            }
            if (data[i].ReqDutyHrs) {
                reqHrs += data[i].ReqDutyHrs;
            }
            if (data[i].WHrs) {
                workHrs += data[i].WHrs;
            }
            if (data[i].DailyOT) {
                overtime += data[i].DailyOT;
            }
            $('#cont_dashboard_AttendanceMonthly').removeClass('d-none');
        }

        $('#dashboard_summary_workdays').text(workDays);
        $('#dashboard_summary_presentdays').text(presentDays);
        $('#dashboard_summary_absentdays').text(absentDays);
        $('#dashboard_summary_ghdays').text(ghDays);
        $('#dashboard_summary_halfdays').text(halfDays);
        $('#dashboard_summary_reqhrs').text(secondsToHHMM(reqHrs));
        $('#dashboard_summary_workhrs').text(secondsToHHMM(workHrs));
        $('#dashboard_summary_overtime').text(secondsToHHMM(overtime));

        this.loader.hideLoader();
    }

    //private GenerateLeaveQuota = async () => {
    //    const response = await http.get(this.constants.leaveController + "/GetLeaveQuotaForDashboard/" + this.userData.Id);
    //    const data = httpPostHandleResponse(response);

    //    let dataQuota: any = [], dataAvailed: any = [], leaveTypes: any = {};

    //    for (let i = 0; i < data.length; i++) {
    //        const leaveType = data[i].LeaveType.replaceAll(' ', '');

    //        dataQuota.push([leaveType, data[i].Quota]);
    //        dataAvailed.push([leaveType, data[i].Availed]);

    //        leaveTypes[leaveType] = {
    //            name: data[i].LeaveType
    //        };
    //    }

    //    $('#cont_dashboard_EmployeeLeaveQuota').removeClass('d-none')

    //    Highcharts.chart('chart_EmployeeLeaveQuota', {
    //        chart: {
    //            type: 'column'
    //        },
    //        leaveTypes,
    //        title: false,
    //        subtitle: false,
    //        plotOptions: {
    //            series: {
    //                grouping: false,
    //                borderWidth: 0
    //            }
    //        },
    //        legend: {
    //            enabled: true
    //        },
    //        tooltip: {
    //            shared: true,
    //            headerFormat: '',
    //            pointFormatter: function () {
    //                const point = this;

    //                return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y + '</b><br/>'
    //            }
    //        },
    //        xAxis: {
    //            type: 'category',
    //            accessibility: {
    //                description: 'leaveTypes'
    //            },
    //            labels: {
    //                useHTML: true,
    //                animate: true,
    //                formatter: function () {
    //                    let _that = this;

    //                    return leaveTypes[_that.value].name;
    //                },
    //                style: {
    //                    textAlign: 'center',
    //                    color: '#000000'
    //                }
    //            }
    //        },
    //        yAxis: [{
    //            title: false,
    //            showFirstLabel: false
    //        }],
    //        series: [{
    //            color: 'rgba(158, 159, 163, 0.5)',
    //            pointPlacement: -0.2,
    //            dataLabels: [{
    //                enabled: true,
    //                style: {
    //                    fontSize: '14px'
    //                }
    //            }],
    //            data: dataQuota.slice(),
    //            name: 'leave Quota'
    //        }, {
    //            color: '#ff7b7b',
    //            name: 'leave Availed',
    //            id: 'main',
    //            dataLabels: [{
    //                enabled: true,
    //                style: {
    //                    fontSize: '14px'
    //                }
    //            }],
    //            data: dataAvailed.slice()
    //        }],
    //        exporting: {
    //            allowHTML: true
    //        }
    //    });
    //}
    private GenerateLeaveQuota = async () => {
        const response = await http.get(this.constants.leaveController + "/GetLeaveQuotaForDashboard/" + this.userData.Id);
        const data = httpPostHandleResponse(response);

        let htmlContent = '';

        // Data par loop chalayein
        data.forEach((item: any) => {
            // Icon select karne ke liye logic (optional)
            let icon = 'scroll-text';
            if (item.LeaveType.toLowerCase().includes('sick')) icon = 'stethoscope';
            if (item.LeaveType.toLowerCase().includes('annual')) icon = 'sun';

            // Har item ke liye HTML structure banayein
            htmlContent += `
            <div class="dash-leave-item d-flex justify-content-between align-items-center mb-2">
                <div class="d-flex align-items-center gap-2">
                    <i data-lucide="${icon}" class="lucide text-muted" style="width:18px"></i>
                    <span class="fw-semibold text-gray-800">${item.LeaveType}</span>
                </div>
                <span class="text-danger fw-semibold">${item.Availed}/${item.Quota}</span>
            </div>
        `;
        });

        // Container mein HTML inject karein
        $('#leave_quota_list').html(htmlContent);

        // Agar Lucide icons use kar rahi hain toh unhein initialize karein
        if (typeof lucide !== 'undefined') {
            lucide.createIcons();
        }

        // Parent container ko show karein
        $('#cont_dashboard_EmployeeLeaveQuota').removeClass('d-none');
    }
    private GenerateEvent = async () => {
        const response = await http.get(this.constants.controller + "/GetEvents");
        const data = httpPostHandleResponse(response);

        if (data.length == 0) {
            $('#noBirthdayFound').removeClass('d-none');
            $('#cnt_dashboard_event_items').empty().addClass('d-none');
        } else {
            $('#noBirthdayFound').addClass('d-none');
            const events = getHtml_HandleBar('#birthdayEventItemTemplate', { data: data });
            $('#cnt_dashboard_event_items').empty().removeClass('d-none').append(events);
        }
    }

    private GenerateBasicInfo = (userData: any) => {
        $('#cont_dashboard_basicprofile').removeClass('d-none');


        $('#lbl_dashboard_Email').text(userData.Email);
        $('#lbl_dashboard_Designation').text(userData.Designation);
        $('#lbl_dashboard_City').text(userData.City);
        $('#lbl_dashboard_Department').text(userData.Department);

        let gender = 'Male';

        if (userData.Gender == 'F' || userData.Gender == 'f' || userData.Gender == 'female' || userData.Gender == 'Female') {
            gender = 'Female';
        }

        $('#lbl_dashboard_Gender').text(gender);

        if (userData.DateOfBirth == null || userData.DateOfBirth == undefined || userData.DateOfBirth == "") {
            $('#lbl_dashboard_DateOfBirth').closest('a').addClass('d-none');
        } else {
            $('#lbl_dashboard_DateOfBirth').text(formatDate_MMMDDYYYY(userData.DateOfBirth));
        }

        if (userData.HireDate == null || userData.HireDate == undefined || userData.HireDate == "") {
            $('#lbl_dashboard_HireDate').closest('a').addClass('d-none');
        } else {
            $('#lbl_dashboard_HireDate').text(formatDate_MMMDDYYYY(userData.HireDate));
        }

        $('#lbl_dashboard_Tenure').text(this.getFormatedStringFromDays(userData.TenureDays));
        $('#lbl_dashboard_Name').text(userData.Name);

        $('#imgUserImage').attr('src', userData.ImagePath);
    }

    private bindEvents = async () => {
        this.$kt_Dashboard_Modal = $(this.constants.kt_Dashboard_Modal);
        $(document).on('themeChanged', this.updateAllChartsTheme);
        $(document).on('change', this.constants.dtpStartDate, this.GenerateAttendanceDailyData);
        this.$gridHeader = $(this.constants.gridDetailsHeader);

        $(document).on('click', '.gridViewProfileContextMenu', this.viewProfileButtonClick);
        $(document).on('click', '.gridViewPayslipContextMenu', this.viewPayslipButtonClick);
        $(document).on('click', '.gridViewAttendanceContextMenu', this.ViewAttendanceButtonClick)
        $(document).on('click', '.gridViewLeaveQuotaContextMenu', this.viewLeaveQuotaButtonClick);

        $(document).on('click', '.drillCNICCountByClient', this.CNICClientByCountClick);
        $(document).on('click', '.gridViewEmpListContextMenu', this.LoadCNICExpiryDetail);

        $(document).on('click', '.drillMissingDocumentEmployeeCountByClient', this.DocumentMissingClientByCountClick);
        $(document).on('click', '.gridViewMissingDocumentEmpListContextMenu', this.LoadMissingDocumentDetail);
        $(document).on('click', '.gridViewMissingDocumentListByEmployeeContextMenu', this.LoadMissingDocumentDetailByEmployee);

        $('.modalDashboardCancelMail').on('click', () => {
            $('#modalDashboardTableBody').removeClass('d-none');
            $('#modalDashboardEmailBody').addClass('d-none');
        });
        $('.modalDashboardSendEmail').on('click', this.SendMail);

        $(document).on('click', '.gridViewNewHireEmployeeByClientContextMenu', this.GetNewHireEmployeesByClient);
        $(document).on('click', '.drillNewHireEmployeeCountByClient', this.NewHireEmployeeBreadcrumMonthClick);

        $(document).on('click', '.gridViewActiveEmployeeByClientContextMenu', this.GetActiveEmployeesByClient);
        $(document).on('click', '.drillActiveEmployeeCountByClient', this.ActiveEmployeeBreadcrumMonthClick);

        $(document).on('click', '.gridViewResignEmployeeByClientContextMenu', this.GetResignEmployeesByClient);
        $(document).on('click', '.drillResignEmployeeCountByClient', this.ResignEmployeeBreadcrumMonthClick);

        $(document).on('click', '.gridViewLeaveRequestByClientContextMenu', this.GetLeaveRequestByClient);
        $(document).on('click', '.drillLeaveRequestCountByClient', this.LeaveRequestBreadcrumMonthClick);

        $(document).on('click', '.gridViewResignRequestByClientContextMenu', this.GetResignRequestByClient);
        $(document).on('click', '.drillResignRequestCountByClient', this.ResignRequestBreadcrumMonthClick);

        $(document).on('click', '.drillClientExpiryCountByClient', this.ClientExpiryByCountClick);

        $(document).on('click', '.drillAgeCountByClient', this.Load60YearByCountClick);
        $(document).on('click', '.gridView60YearsEmpListContextMenu', this.Load60YearDetail);

        $(document).on('click', '.drillAbsentLeaveCountByClient', this.GetAbsentLeaveCountByClientCountClick);
        $(document).on('click', '.gridViewAbsentLeaveEmpListContextMenu', this.LoadAbsentLeaveDetail);

        $(document).on('change', this.constants.dtpStartDate, this.GenerateAttendanceDailyData);

        let today: any = moment(),
            start: any = moment().subtract(0, 'months').startOf('month'),
            end: any = moment();

        //bindBootstrapDatePicker(this.constants.dtpStartDate, "M d, yyyy", "days", "years", null, null, null, "bottom");
        //bindFlatpickr(
        //    '#dtpStartDate', // Use the actual control ID selector
        //    "M d, Y",
        //    "days",
        //    "years",
        //    null,
        //    null,
        //    null,
        //    "bottom"
        //);

        bindFlatpickr(
            '#dtpStartDate',
            "M d, Y", 
            "days",
            "years",
           
        );
        bindFlatpickrRange(
            '#dtpStartDate_2',
            "M d, Y",
            "days",
            "years",
            null,
            null,
            null,
            "bottom",
            true,
            this.GenerateAttendanceSummaryData.bind(this)
        );
        //bindBootstrap5DatePicker('#dtpStartDate', 'M d, yyyy');

        //let ranges: any = {
        //    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        //    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        //    'This Month': [moment().startOf('month'), moment()],
        //    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        //};

        //bindDateRangePicker("#dtSearchDate_2", this.constants.dtpStartDate_2, "MMM DD, YYYY", start, end, null, 1, null, this.GenerateAttendanceSummaryData, ranges
        //);



    }

    private getFormatedStringFromDays = (numberOfDays: any) => {
        var years = Math.floor(numberOfDays / 365);
        var months = Math.floor(numberOfDays % 365 / 30);
        var days = Math.floor(numberOfDays % 365 % 30);
        return years + (years > 1 ? " Years " : " Year ") + months + (months > 1 ? " Months " : " Month ") + days + (days > 1 ? " Days " : " Day ");
    }

    private checkMissingMandatoryDocument = async () => {
        GetToken();

        const request: any = {
            IsMandatory: 1,
            EmployeeId: 0,
            ClientId: 0
        }
        const response = await http.post(this.constants.controllerDocumentType + "/GetMissingDocumentListByEmployee", request);
        const data = httpPostHandleResponse(response);

        if (data.Documents.length > 0) {

            const missingDocumentsMessage = "Some Mandatory documents are missing. Please upload below documents at your earliest. <a href='" + baseWebUrl() + '/setup/profile?tabid=kt_tabs_7_3' + "' style='font-weight: bold; text-decoration: underline;'>Click Here</a> to upload the missing documents...",
                cont = $('#divDashboardNotificationsCont');

            let iDoc = 0,
                lDoc = data.Documents.length,
                html = '';

            for (iDoc; iDoc < lDoc; iDoc++) {
                html += '<div class="col-2 ml-2" style="border: 1px solid black; text-align: center;">' + data.Documents[iDoc].Name + '</div>';
            }

            cont.append('<div class="row"><div class="col-12">' + missingDocumentsMessage + '</div></div>')
                .append('<div class="row">' + html + '</div>')
                .removeClass('d-none');

            //toastr.warning("Some Mandatory documents are missing. Please upload below documents at your earliest. <a href='" + baseWebUrl() + '/setup/profile?tabid=kt_tabs_7_3' + "' style='font-weight: bold; text-decoration: underline;'>Click Here</a> to view the missing document list", "Warning", { closeButton: true, positionClass: 'toast-top-full-width', timeOut: 0, extendedTimeOut: 0 });
        }

        //divDashboardNotificationsCont
    }

    private CNICClientByCountClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        const typeId: number = $(event.currentTarget).closest('div.cust-actions').data('typeid');

        this.LoadCNICExpiryByClient(typeId);
    }

    private viewProfileButtonClick = (event: JQueryEventObject) => {
        const id: number = $(event.currentTarget).closest('div.cust-actions').data('id');

        const url = baseWebUrl() + '/setup/Profile?key=' + id;

        window.open(url, "DescriptiveWindowName", "resizable,scrollbars,status");
    }

    private viewLeaveQuotaButtonClick = async (event: JQueryEventObject) => {

        const id: number = $(event.currentTarget).closest('div.cust-actions').data('id');

        const url = baseWebUrl() + '/Management/Leave?userKey=' + id;

        window.open(url, "DescriptiveWindowName", "resizable,scrollbars,status");
    }

    private viewPayslipButtonClick = (event: JQueryEventObject) => {
        const id: number = $(event.currentTarget).closest('div.cust-actions').data('id');

        const url = baseWebUrl() + '/setup/Payslip?key=' + id;

        window.open(url, "DescriptiveWindowName", "resizable,scrollbars,status");
    }

    private ViewAttendanceButtonClick = (event: JQueryEventObject) => {
        const id: number = $(event.currentTarget).closest('div.cust-actions').data('id');

        const url = baseWebUrl() + '/Attendence/AttendenceReport?key=' + id;

        window.open(url, "DescriptiveWindowName", "resizable,scrollbars,status");
    }

    private LoadWithoutLeaveAbsence = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetAbsentLeaveCount");
        const data = httpPostHandleResponse(response);

        let chartData = [];

        let idata = 0,
            ldata = data.length;

        for (idata; idata < ldata; idata++) {
            chartData.push({ name: data[idata].MonthFormatted, y: data[idata].AbsentDays });
        }

        this.loader.hideLoader();
        $('#divWithoutLeaveAbsence').removeClass('d-none');

        Highcharts.chart('divWithoutLeaveAbsence', {

            chart: {
                type: 'bar'
            },
            title: {
                text: ''
            },
            legend: {
                enabled: false
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: null
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    },
                    cursor: 'pointer',
                    events: {
                        click: (event: any) => {
                            const typeName = event.point.name;

                            this.drillBreadCrumb = [];

                            this.drillBreadCrumb[0] = {
                                type: typeName,
                                typePropName: 'typeid',
                                name: typeName,
                                className: 'drillAbsentLeaveCountByClient',
                                isDrillDownEnable: false
                            };

                            const date = new Date(typeName);

                            this.LoadWithoutLeaveAbsenceByClient(date.getMonth() + 1, date.getFullYear());
                        }
                    }
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
            },
            series: [
                {
                    name: "AbsentLeaveCount",
                    colorByPoint: true,
                    data: chartData
                }
            ]
        });
    }

    private LoadWithoutLeaveAbsenceByClient = async (month: any, year: any) => {
        this.loader.showLoader();
        GetToken();

        let dataToSend = { Month: month, Year: year };

        const response = await http.post(this.constants.controller + "/GetAbsentLeaveCountByClient", dataToSend);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Age Count ' + this.drillBreadCrumb[0].name + ' by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-monthid="' + month + '" data-yearid="' + year + '" data-id="' + full.ClientId + '"><a href="javascript:;" class="btn btn-clean gridViewAbsentLeaveEmpListContextMenu" title="View Employees">' + data + '</a></div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private GetAbsentLeaveCountByClientCountClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        const date = new Date($(event.currentTarget).closest('div.cust-actions').data('typeid'));

        this.LoadWithoutLeaveAbsenceByClient(date.getMonth() + 1, date.getFullYear());
    }

    private LoadAbsentLeaveDetail = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            month: number = actions.data('monthid'),
            year: number = actions.data('yearid'),
            clientId: number = actions.data('id');

        const request: any = {
            ClientId: clientId,
            Month: month,
            Year: year
        }

        this.drillBreadCrumb[0].isDrillDownEnable = true;

        this.drillBreadCrumb[1] = {
            type: formatDate_MMMYYYY(new Date(year + '-' + month + '-1')),
            typePropName: 'typeid',
            client: clientId,
            clientPrpName: 'clientid',
            name: actions.closest('tr').children('td:first').text(),
            className: 'gridViewAbsentLeaveEmpListContextMenu',
            isDrillDownEnable: false
        };

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetAbsentLeaveCountDetail", request);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Department", "Employee", "Date", "Reports"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Dept' },
            { data: 'Name' },
            { data: 'Date' },
            { data: 'Name', width: '300px' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Absenteeism Report(Without Leave Submission) ' + this.drillBreadCrumb[0].name + ' - ' + this.drillBreadCrumb[1].name + ' Employees',
                        exportOptions: {
                            columns: [0, 1, 2]
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        targets: 1,
                        className: 'dt-left',
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.UserId + '">'
                                + '<a href="javascript:;" style="text-align:left;" class="btn btn-clean gridViewProfileContextMenu" title="View Employee\'s Profile">' + data + '</a>'
                                + '</div>';
                        }
                    }, {
                        targets: 3,
                        className: 'dt-left',

                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.UserId + '">'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewPayslipContextMenu" title="View Employee\'s Payslip">Payslip</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewLeaveQuotaContextMenu" title="View Employee\'s Leave Quota">Leave Quota</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewAttendanceContextMenu" title="View Employee\'s Attendance">Attendance</a>'
                                + '</div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }

    private LoadCNICExpiryCount = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetExpiryCount");
        const data = httpPostHandleResponse(response);

        const chartData = [{
            name: "Missing",
            y: data.MissingCount
        }, {
            name: "Expired",
            y: data.ExpiredCount
        }, {
            name: "Expire in 30 Days",
            y: data.Count30
        }, {
            name: "Expire in 60 Days",
            y: data.Count60
        }]

        this.loader.hideLoader();
        $('#divCNICExpireCount').removeClass('d-none');

        Highcharts.chart('divCNICExpireCount', {

            chart: {
                type: 'column'
            },
            backgroundColor: '#2b2b3b',
            title: {
                text: ''
            },
            legend: {
                enabled: false
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: null
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    },
                    cursor: 'pointer',
                    events: {
                        click: (event: any) => {
                            const typeName = event.point.name;
                            let type: any = 0;

                            if (typeName == "Missing") type = 0;
                            else if (typeName == "Expired") type = 1;
                            else if (typeName == "Expire in 30 Days") type = 2;
                            else if (typeName == "Expire in 60 Days") type = 3;

                            this.drillBreadCrumb = [];

                            this.drillBreadCrumb[0] = {
                                type: type,
                                typePropName: 'typeid',
                                name: typeName,
                                className: 'drillCNICCountByClient',
                                isDrillDownEnable: false
                            };

                            this.LoadCNICExpiryByClient(type);
                        }
                    }
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
            },
            series: [
                {
                    name: "ID Card",
                    colorByPoint: true,
                    data: chartData
                }
            ]
        });
    }

    private LoadCNICExpiryByClient = async (type: any) => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetCNICExpiryByClient/" + type);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'ID Card ' + this.drillBreadCrumb[0].name + ' by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-typeid="' + type + '" data-id="' + full.ClientId + '"><a href="javascript:;" class="btn btn-clean gridViewEmpListContextMenu" title="View Employees">' + data + '</a></div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private LoadCNICExpiryDetail = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            typeId: number = actions.data('typeid'),
            clientId: number = actions.data('id');

        const request: any = {
            ClientId: clientId,
            Type: typeId
        }

        this.drillBreadCrumb[0].isDrillDownEnable = true;

        this.drillBreadCrumb[1] = {
            type: typeId,
            typePropName: 'typeid',
            client: clientId,
            clientPrpName: 'clientid',
            name: actions.closest('tr').children('td:first').text(),
            className: 'gridViewEmpListContextMenu',
            isDrillDownEnable: false
        };

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetCNICExpiryDetail", request);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Department", "Employee", "Reports"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Dept' },
            { data: 'Name' },
            { data: 'Name', width: '300px' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'ID Card ' + this.drillBreadCrumb[0].name + ' - ' + this.drillBreadCrumb[1].name + ' Employees',
                        exportOptions: {
                            columns: [0, 1]
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        targets: 1,
                        className: 'dt-left',
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.UserId + '">'
                                + '<a href="javascript:;" style="text-align:left;" class="btn btn-clean gridViewProfileContextMenu" title="View Employee\'s Profile">' + data + '</a>'
                                + '</div>';
                        }
                    }, {
                        targets: 2,
                        className: 'dt-left',

                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.UserId + '">'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewPayslipContextMenu" title="View Employee\'s Payslip">Payslip</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewLeaveQuotaContextMenu" title="View Employee\'s Leave Quota">Leave Quota</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewAttendanceContextMenu" title="View Employee\'s Attendance">Attendance</a>'
                                + '</div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }

    private generateModalBreadCrumb = async () => {
        const breadCrumbHtml = getHtml_HandleBar('#modalBreadCrumbTemplate', { data: this.drillBreadCrumb });
        $('#modalTitle').empty().html(breadCrumbHtml);
    }

    private LoadClientExpiryCount = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetClientContractExpiryCount");
        const data = httpPostHandleResponse(response);

        const chartData = [{
            name: "Missing",
            y: (data.Missing == undefined || data.Missing == null) ? 0 : data.Missing
        }, {
            name: "Expired",
            y: (data.Expired == undefined || data.Expired == null) ? 0 : data.Expired
        }, {
            name: "Expire in 30 Days",
            y: (data.ExpiredIn30Days == undefined || data.ExpiredIn30Days == null) ? 0 : data.ExpiredIn30Days
        }, {
            name: "Expire in 60 Days",
            y: (data.ExpiredIn60Days == undefined || data.ExpiredIn60Days == null) ? 0 : data.ExpiredIn60Days
        }]

        this.loader.hideLoader();
        $('#divClientExpiryCount').removeClass('d-none');

        Highcharts.chart('divClientExpiryCount', {

            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            legend: {
                enabled: false
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: null
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    },
                    cursor: 'pointer',
                    events: {
                        click: (event: any) => {
                            const typeName = event.point.name;
                            let type: any = 0;

                            if (typeName == "Expired") type = 0;
                            else if (typeName == "Missing") type = 3;
                            else if (typeName == "Expire in 30 Days") type = 1;
                            else if (typeName == "Expire in 60 Days") type = 2;

                            this.drillBreadCrumb = [];

                            this.drillBreadCrumb[0] = {
                                type: type,
                                typePropName: 'typeid',
                                name: typeName,
                                className: 'drillClientExpiryCountByClient',
                                isDrillDownEnable: false
                            };

                            this.LoadClientExpiryByClient(type);
                        }
                    }
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
            },
            series: [
                {
                    name: "ClientContractExpiry",
                    colorByPoint: true,
                    data: chartData
                }
            ]
        });
    }

    private LoadClientExpiryByClient = async (type: any) => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetClientContractExpiryCountByClient/" + type);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Client", "Inception", "Start Date", "Expiry Date"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Inception' },
            { data: 'StartDate' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Clients Contract Expiry ' + this.drillBreadCrumb[0].name + ' by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return data;
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private ClientExpiryByCountClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        const typeId: number = $(event.currentTarget).closest('div.cust-actions').data('typeid');

        this.LoadClientExpiryByClient(typeId);
    }

    private Load60YearCount = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetAgeCount");
        const data = httpPostHandleResponse(response);

        const chartData = [{
            name: "Below 40 Years",
            y: data.Below40Age
        }, {
            name: "Between 40 And 50 Years",
            y: data.Between40And50Age
        }, {
            name: "Between 50 And 60 Years",
            y: data.Between50And60Age
        }, {
            name: "Above 60 Years",
            y: data.Above60Age
        }]

        this.loader.hideLoader();
        $('#div60YearCount').removeClass('d-none');

        Highcharts.chart('div60YearCount', {

            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            legend: {
                enabled: false
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: null
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    },
                    cursor: 'pointer',
                    events: {
                        click: (event: any) => {
                            const typeName = event.point.name;
                            let type: any = 0;

                            if (typeName == "Below 40 Years") type = 0;
                            else if (typeName == "Between 40 And 50 Years") type = 1;
                            else if (typeName == "Between 50 And 60 Years") type = 2;
                            else if (typeName == "Above 60 Years") type = 3;

                            this.drillBreadCrumb = [];

                            this.drillBreadCrumb[0] = {
                                type: type,
                                typePropName: 'typeid',
                                name: typeName,
                                className: 'drillAgeCountByClient',
                                isDrillDownEnable: false
                            };

                            this.Load60YearByClient(type);
                        }
                    }
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
            },
            series: [
                {
                    name: "ClientContractExpiry",
                    colorByPoint: true,
                    data: chartData
                }
            ]
        });
    }

    private Load60YearByClient = async (type: any) => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetAgeCountByClient/" + type);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Age Count ' + this.drillBreadCrumb[0].name + ' by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-typeid="' + type + '" data-id="' + full.ClientId + '"><a href="javascript:;" class="btn btn-clean gridView60YearsEmpListContextMenu" title="View Employees">' + data + '</a></div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private Load60YearByCountClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        const typeId: number = $(event.currentTarget).closest('div.cust-actions').data('typeid');

        this.Load60YearByClient(typeId);
    }

    private Load60YearDetail = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            typeId: number = actions.data('typeid'),
            clientId: number = actions.data('id');

        const request: any = {
            ClientId: clientId,
            Type: typeId
        }

        this.drillBreadCrumb[0].isDrillDownEnable = true;

        this.drillBreadCrumb[1] = {
            type: typeId,
            typePropName: 'typeid',
            client: clientId,
            clientPrpName: 'clientid',
            name: actions.closest('tr').children('td:first').text(),
            className: 'gridView60YearsEmpListContextMenu',
            isDrillDownEnable: false
        };

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controller + "/GetAgeCountDetail", request);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Department", "Employee", "Reports"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Dept' },
            { data: 'Name' },
            { data: 'Name', width: '300px' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'ID Card ' + this.drillBreadCrumb[0].name + ' - ' + this.drillBreadCrumb[1].name + ' Employees',
                        exportOptions: {
                            columns: [0, 1]
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        targets: 1,
                        className: 'dt-left',
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.UserId + '">'
                                + '<a href="javascript:;" style="text-align:left;" class="btn btn-clean gridViewProfileContextMenu" title="View Employee\'s Profile">' + data + '</a>'
                                + '</div>';
                        }
                    }, {
                        targets: 2,
                        className: 'dt-left',

                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.UserId + '">'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewPayslipContextMenu" title="View Employee\'s Payslip">Payslip</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewLeaveQuotaContextMenu" title="View Employee\'s Leave Quota">Leave Quota</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewAttendanceContextMenu" title="View Employee\'s Attendance">Attendance</a>'
                                + '</div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }

    private LoadMissingDocumentCount = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controllerDocumentType + "/GetMissingDocumentEmployeeCountByCategory");
        const data = httpPostHandleResponse(response);
        
        const chartData = [{
            name: "Missing Mandatory Documents",
            y: data.MissingMandatoryDocuments
        }, {
            name: "Missing Optional Documents",
            y: data.MissingOptionalDocuments
        }]

        this.loader.hideLoader();
        $('#divEmployeeDocuments').removeClass('d-none');

        Highcharts.chart('divEmployeeDocuments', {

            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            legend: {
                enabled: false
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: null
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    },
                    cursor: 'pointer',
                    events: {
                        click: (event: any) => {
                            const typeName = event.point.name;
                            let type: any = 0;

                            if (typeName == "Missing Mandatory Documents") type = 1;
                            else if (typeName == "Missing Optional Documents") type = 0;

                            this.drillBreadCrumb = [];

                            this.drillBreadCrumb[0] = {
                                type: type,
                                typePropName: 'typeid',
                                name: typeName,
                                className: 'drillMissingDocumentEmployeeCountByClient',
                                isDrillDownEnable: false
                            };

                            this.LoadMissingDocumentByClient(type);
                        }
                    }
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
            },
            series: [
                {
                    name: "Missing Documents",
                    colorByPoint: true,
                    data: chartData
                }
            ]
        });
    }

    private LoadMissingDocumentByClient = async (type: any) => {
        this.loader.showLoader();
        GetToken();

        let dataToSend = { IsMandatory: type };

        const response = await http.post(this.constants.controllerDocumentType + "/GetMissingDocumentEmployeeCountByClient", dataToSend);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Missing Document ' + this.drillBreadCrumb[0].name + ' by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-typeid="' + type + '" data-clientid="' + full.ClientId + '"><a href="javascript:;" class="btn btn-clean gridViewMissingDocumentEmpListContextMenu" title="View Employees">' + data + '</a></div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private LoadMissingDocumentDetail = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            typeId: number = actions.data('typeid'),
            clientId: number = actions.data('clientid');

        const request: any = {
            ClientId: clientId,
            IsMandatory: typeId
        }

        if (this.drillBreadCrumb.length > 2) {
            this.drillBreadCrumb[1].isDrillDownEnable = false;
            this.drillBreadCrumb = [this.drillBreadCrumb[0], this.drillBreadCrumb[1]];
        } else {
            this.drillBreadCrumb[0].isDrillDownEnable = true;

            this.drillBreadCrumb[1] = {
                type: typeId,
                typePropName: 'typeid',
                client: clientId,
                clientPrpName: 'clientid',
                name: actions.closest('tr').children('td:first').text(),
                className: 'gridViewMissingDocumentEmpListContextMenu',
                isDrillDownEnable: false
            };
        }

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controllerDocumentType + "/GetMissingDocumentEmployeeCountByEmployee", request);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Department", "Employee", "Count", "Reports"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Dept' },
            { data: 'Employee' },
            { data: 'Count' },
            { data: 'Employee', width: '300px' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Missing Documents ' + this.drillBreadCrumb[0].name + ' - ' + this.drillBreadCrumb[1].name + ' Employees',
                        exportOptions: {
                            columns: [0, 1]
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        targets: 1,
                        className: 'dt-left',
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;" class="btn btn-clean gridViewProfileContextMenu" title="View Employee\'s Profile">' + data + '</a>'
                                + '</div>';
                        }
                    }, {
                        targets: 2,
                        className: 'dt-right',
                        render: function (data, e, full) {
                            return '<div class="cust-actions" data-typeid="' + typeId + '" data-clientid="' + clientId + '"data-employeeid="' + full.EmployeeId + '" ><a href="javascript:;" class="btn btn-clean gridViewMissingDocumentListByEmployeeContextMenu" title="View Missing Documents">' + data + '</a></div>';
                        }
                    }, {
                        targets: 3,
                        className: 'dt-left',

                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewPayslipContextMenu" title="View Employee\'s Payslip">Payslip</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewLeaveQuotaContextMenu" title="View Employee\'s Leave Quota">Leave Quota</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewAttendanceContextMenu" title="View Employee\'s Attendance">Attendance</a>'
                                + '</div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }

    private LoadMissingDocumentDetailByEmployee = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            typeId: number = actions.data('typeid'),
            clientId: number = actions.data('clientid'),
            employeeId: number = actions.data('employeeid');

        const request: any = {
            ClientId: clientId,
            IsMandatory: typeId,
            Employeeid: employeeId
        }

        if (this.drillBreadCrumb.length > 3) {
            this.drillBreadCrumb[2].isDrillDownEnable = false;
            this.drillBreadCrumb = [this.drillBreadCrumb[0], this.drillBreadCrumb[1], this.drillBreadCrumb[2]];
        } else {
            this.drillBreadCrumb[1].isDrillDownEnable = true;

            this.drillBreadCrumb[2] = {
                type: typeId,
                typePropName: 'typeid',
                client: clientId,
                clientPrpName: 'clientid',
                employee: employeeId,
                employeePrpName: 'employeeid',
                name: actions.closest('tr').children('td')[1].innerText,
                className: 'gridViewMissingDocumentEmpListContextMenu',
                isDrillDownEnable: false
            };
        }

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.controllerDocumentType + "/GetMissingDocumentListByEmployee", request);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Name"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Name' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Missing Documents ' + this.drillBreadCrumb[0].name + ' - ' + this.drillBreadCrumb[1].name + ' - ' + this.drillBreadCrumb[2].name,
                        exportOptions: {
                            columns: [0]
                        }
                    },
                    {
                        text: 'Send Email',
                        className: 'sendEmail',
                        action: (e, dt) => {
                            $('#modalDashboardTxtTo').val(data.Email + ';');
                            $('#modalDashboardTxtCc').closest('.col-11').removeClass('d-none');
                            $('.modalDashboardSendEmail').text('Send Email');

                            let bodyText = "Dear " + data.Name + ",\n\nBelow Mentioned Documents are missing:";

                            let i = 0,
                                l = data.Documents.length;

                            for (i; i < l; i++) {
                                bodyText += '\n- ' + data.Documents[i].Name;
                            }

                            bodyText += "\n\nRegards,\n" + data.PortalName + " HRMS"

                            $('#modalDashboardTxtEmailBody').val(bodyText);

                            $('#modalDashboardTableBody').addClass('d-none');
                            $('#modalDashboardEmailBody').removeClass('d-none');
                        }
                    },
                    {
                        text: 'Send SMS',
                        className: 'sendSMS',
                        action: (e, dt) => {
                            $('#modalDashboardTxtTo').val(data.PhoneNumber);
                            $('#modalDashboardTxtCc').closest('.col-11').addClass('d-none');
                            $('.modalDashboardSendEmail').text('Send SMS');

                            let bodyText = "Dear " + data.Name + ",\n\nBelow Mentioned Documents are missing:\n";

                            let i = 0,
                                l = data.Documents.length;

                            for (i; i < l; i++) {
                                bodyText += '\n' + data.Documents[i].Name;
                            }

                            bodyText += "\n\nRegards,\n" + data.PortalName + " HRMS"

                            $('#modalDashboardTxtEmailBody').val(bodyText);

                            $('#modalDashboardTableBody').addClass('d-none');
                            $('#modalDashboardEmailBody').removeClass('d-none');
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data.Documents,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }

    private SendMail = async () => {
        this.loader.showLoader();

        const dataToSent = {
            To: $('#modalDashboardTxtTo').val(),
            Cc: $('#modalDashboardTxtCc').val(),
            Subject: $('#modalDashboardTxtSubject').val(),
            Body: $('#modalDashboardTxtEmailBody').val()
        };

        GetToken();

        const buttonText = $('.modalDashboardSendEmail').text();

        let url = this.constants.controller + "/SendMail";

        if (buttonText.indexOf('SMS') > -1) {
            url = this.constants.controller + "/SendSMS";
        }

        const response = await http.post(url, dataToSent);
        const data = httpPostHandleResponse(response);

        if (data) {

            let message = "Notification Email sent to employee!";

            if (buttonText.indexOf('SMS') > -1) {
                message = "Notification SMS sent to employee!";
            }

            sweetAlert(AlertType.Success, AlertTitle.Success, message);
            $('.modalDashboardCancelMail').trigger('click');
        }

        this.loader.hideLoader();
    }

    private DocumentMissingClientByCountClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        const typeId: number = $(event.currentTarget).closest('div.cust-actions').data('typeid');

        this.LoadMissingDocumentByClient(typeId);
    }

    private LoadEmployeeInfoUpdateRequestCount = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.employeeController + "/GetEmployeeUpdateInfoRequestForChart");
        const data = httpPostHandleResponse(response);

        this.EmployeeUpdateInfoRequestData = data;

        let entertained = 0, pending = 0, pendingforLast30Days = 0, i = 0;

        if (this.EmployeeUpdateInfoRequestData && this.EmployeeUpdateInfoRequestData.length > 0) {
            for (i; i < this.EmployeeUpdateInfoRequestData.length; i++) {
                entertained += this.EmployeeUpdateInfoRequestData[i].Entertained;
                pending += this.EmployeeUpdateInfoRequestData[i].Pending;
                pendingforLast30Days += this.EmployeeUpdateInfoRequestData[i].PendingForLast30Days;
            }
        }

        const chartData = [{
            name: "Entertained",
            y: entertained
        }, {
            name: "Pending",
            y: pending
        }, {
            name: "Pending for last 30 Days",
            y: pendingforLast30Days
        }]

        this.loader.hideLoader();
        $('#divEmployeeInfoUpdateRequestCount').removeClass('d-none');

        Highcharts.chart('divEmployeeInfoUpdateRequestCount', {

            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            legend: {
                enabled: false
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: null
                }
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    },
                    cursor: 'pointer',
                    events: {
                        click: (event: any) => {
                            const typeName = event.point.name;
                            let type: any = 0;

                            if (typeName == "Entertained") type = 0;
                            else if (typeName == "Pending") type = 1;
                            else if (typeName == "Pending for last 30 Days") type = 2;

                            this.drillBreadCrumb = [];

                            this.drillBreadCrumb[0] = {
                                type: type,
                                typePropName: 'typeid',
                                name: typeName,
                                className: 'drillCNICCountByClient',
                                isDrillDownEnable: false
                            };

                            this.LoadEmployeeInfoUpdateRequestCountByClient(type);
                        }
                    }
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
            },
            series: [
                {
                    name: "EmployeeInfo",
                    colorByPoint: true,
                    data: chartData
                }
            ]
        });
    }

    private LoadEmployeeInfoUpdateRequestCountByClient = async (type: any) => {
        this.loader.showLoader();
        GetToken();

        let data: any = [];

        if (this.EmployeeUpdateInfoRequestData.length > 0) {

            let i = 0;

            for (i; i < this.EmployeeUpdateInfoRequestData.length; i++) {
                if (type == 0) {
                    data.push({
                        Client: this.EmployeeUpdateInfoRequestData[i].ClientName,
                        Count: this.EmployeeUpdateInfoRequestData[i].Entertained
                    });
                }
                else if (type == 1) {
                    data.push({
                        Client: this.EmployeeUpdateInfoRequestData[i].ClientName,
                        Count: this.EmployeeUpdateInfoRequestData[i].Pending
                    });
                }
                else if (type == 2) {
                    data.push({
                        Client: this.EmployeeUpdateInfoRequestData[i].ClientName,
                        Count: this.EmployeeUpdateInfoRequestData[i].PendingForLast30Days
                    });
                }
            }
        }

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'ID Card ' + this.drillBreadCrumb[0].name + ' by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private loadNewHires = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.employeeController + "/GetNewHireEmployeeCount");
        const data = httpPostHandleResponse(response);
        if (data) {

            let chartData = [];

            let idata = 0,
                ldata = data.length;

            for (idata; idata < ldata; idata++) {
                chartData.push({ name: data[idata].MonthFormatted, y: data[idata].Count });
            }

            this.loader.hideLoader();
            $('#divNewHires').removeClass('d-none');

            Highcharts.chart('divNewHires', {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: ''
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    type: 'category'
                },
                yAxis: {
                    title: {
                        text: null
                    }
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y}'
                        },
                        cursor: 'pointer',
                        events: {
                            click: (event: any) => {
                                const typeName = event.point.name;

                                this.drillBreadCrumb = [];

                                this.drillBreadCrumb[0] = {
                                    type: typeName,
                                    typePropName: 'typeid',
                                    name: typeName,
                                    className: 'drillNewHireEmployeeCountByClient',
                                    isDrillDownEnable: false
                                };

                                const date = new Date(typeName);

                                this.LoadNewHireEmployeeCountByClient(date.getMonth() + 1, date.getFullYear());
                            }
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                    pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
                },
                series: [
                    {
                        name: "New Hires",
                        colorByPoint: true,
                        data: chartData
                    }
                ]
            });
        }
    }

    private LoadNewHireEmployeeCountByClient = async (month: any, year: any) => {
        this.loader.showLoader();
        GetToken();

        let dataToSend = { Month: month, Year: year };

        const response = await http.post(this.constants.employeeController + "/GetNewHireEmployeeCountByClient", dataToSend);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'New Hire ' + this.drillBreadCrumb[0].name + ' by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-monthid="' + month + '" data-yearid="' + year + '" data-clientid="' + full.ClientId + '"><a href="javascript:;" class="btn btn-clean gridViewNewHireEmployeeByClientContextMenu" title="View Employees">' + data + '</a></div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private GetNewHireEmployeesByClient = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            month: number = actions.data('monthid'),
            year: number = actions.data('yearid'),
            clientId: number = actions.data('clientid');

        const request: any = {
            ClientId: clientId,
            Month: month,
            Year: year
        }

        this.drillBreadCrumb[0].isDrillDownEnable = true;

        this.drillBreadCrumb[1] = {
            type: formatDate_MMMYYYY(new Date(year + '-' + month + '-1')),
            typePropName: 'typeid',
            client: clientId,
            clientPrpName: 'clientid',
            name: actions.closest('tr').children('td:first').text(),
            className: 'gridViewEmpListContextMenu',
            isDrillDownEnable: false
        };

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.employeeController + "/GetNewHireEmployeesByClient", request);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Department", "Employee", "Reports"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Dept' },
            { data: 'Employee' },
            { data: 'Employee', width: '300px' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'New Hire ' + this.drillBreadCrumb[0].name + ' - ' + this.drillBreadCrumb[1].name + ' Employees',
                        exportOptions: {
                            columns: [0, 1]
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        targets: 1,
                        className: 'dt-left',
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;" class="btn btn-clean gridViewProfileContextMenu" title="View Employee\'s Profile">' + data + '</a>'
                                + '</div>';
                        }
                    }, {
                        targets: 2,
                        className: 'dt-left',

                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewPayslipContextMenu" title="View Employee\'s Payslip">Payslip</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewLeaveQuotaContextMenu" title="View Employee\'s Leave Quota">Leave Quota</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewAttendanceContextMenu" title="View Employee\'s Attendance">Attendance</a>'
                                + '</div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }

    private NewHireEmployeeBreadcrumMonthClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        const date = new Date($(event.currentTarget).closest('div.cust-actions').data('typeid'));

        this.LoadNewHireEmployeeCountByClient(date.getMonth() + 1, date.getFullYear());
    }

    private loadActiveEmployees = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.employeeController + "/GetActiveEmployeeCount");
        const data = httpPostHandleResponse(response);

        if (data) {

            let xAxis = [],
                yAxisHris = [],
                yAxisPayroll = [],
                iData = 0,
                lData = data.length,
                chartData = [];

            for (iData; iData < lData; iData++) {
                if (xAxis.indexOf(data[iData].MonthFormatted) == -1) {
                    xAxis.push(data[iData].MonthFormatted);
                }

                if (data[iData].Type == 'HRIS') {
                    yAxisHris.push(data[iData].Count);
                }

                if (data[iData].Type == 'Payroll') {
                    yAxisPayroll.push(data[iData].Count);
                }
            };

            chartData.push({ name: 'HRIS', data: yAxisHris });
            chartData.push({ name: 'Payroll', data: yAxisPayroll });

            this.loader.hideLoader();
            $('#divActiveEmployee').removeClass('d-none');

            Highcharts.chart('divActiveEmployee', {
                chart: {
                    type: 'spline'
                },
                legend: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: xAxis
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: function () {
                            return (this.value / 1000) + 'k';
                        }
                    }
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            format: '{}{point.y}'
                        },
                        cursor: 'pointer',
                        events: {
                            click: (event: any) => {
                                const typeName = event.point.category;

                                this.drillBreadCrumb = [];

                                this.drillBreadCrumb[0] = {
                                    type: typeName,
                                    typePropName: 'typeid',
                                    name: event.point.series.name + ' - ' + event.point.category,
                                    className: 'drillActiveEmployeeCountByClient',
                                    isDrillDownEnable: false
                                };

                                const date = new Date(typeName);

                                this.LoadActiveEmployeeCountByClient(date.getMonth() + 1, date.getFullYear(), event.point.series.name);
                            }
                        }
                    }
                },
                series: [{
                    name: 'HRIS',
                    data: yAxisHris
                }, {
                    name: 'Payroll',
                    data: yAxisPayroll
                }]
            });
        }
    }

    private LoadActiveEmployeeCountByClient = async (month: any, year: any, type: any) => {
        this.loader.showLoader();
        GetToken();

        let dataToSend = {
            Month: month, Year: year,
            Type: this.drillBreadCrumb[0].name.split('-')[0].trim()
        };

        const response = await http.post(this.constants.employeeController + "/GetActiveEmployeeCountByClient", dataToSend);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Active Employee ' + this.drillBreadCrumb[0].name + ' by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-monthid="' + month + '" data-yearid="' + year + '" data-clientid="' + full.ClientId + '"><a href="javascript:;" class="btn btn-clean gridViewActiveEmployeeByClientContextMenu" title="View Employees">' + data + '</a></div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private GetActiveEmployeesByClient = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            month: number = actions.data('monthid'),
            year: number = actions.data('yearid'),
            clientId: number = actions.data('clientid');

        const request: any = {
            ClientId: clientId,
            Month: month,
            Year: year,
            Type: this.drillBreadCrumb[0].name.split('-')[0].trim()
        }

        this.drillBreadCrumb[0].isDrillDownEnable = true;

        this.drillBreadCrumb[1] = {
            type: formatDate_MMMYYYY(new Date(year + '-' + month + '-1')),
            typePropName: 'typeid',
            client: clientId,
            clientPrpName: 'clientid',
            name: actions.closest('tr').children('td:first').text(),
            className: 'gridViewEmpListContextMenu',
            isDrillDownEnable: false
        };

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.employeeController + "/GetActiveEmployeesByClient/", request);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Department", "Employee", "Reports"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Dept' },
            { data: 'Employee' },
            { data: 'Employee', width: '300px' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'New Hire ' + this.drillBreadCrumb[0].name + ' - ' + this.drillBreadCrumb[1].name + ' Employees',
                        exportOptions: {
                            columns: [0, 1]
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        targets: 1,
                        className: 'dt-left',
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;" class="btn btn-clean gridViewProfileContextMenu" title="View Employee\'s Profile">' + data + '</a>'
                                + '</div>';
                        }
                    }, {
                        targets: 2,
                        className: 'dt-left',

                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewPayslipContextMenu" title="View Employee\'s Payslip">Payslip</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewLeaveQuotaContextMenu" title="View Employee\'s Leave Quota">Leave Quota</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewAttendanceContextMenu" title="View Employee\'s Attendance">Attendance</a>'
                                + '</div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }

    private ActiveEmployeeBreadcrumMonthClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        const date = new Date($(event.currentTarget).closest('div.cust-actions').data('typeid'));

        this.LoadActiveEmployeeCountByClient(date.getMonth() + 1, date.getFullYear(), this.drillBreadCrumb[0].name.split('-')[0].trim());
    }

    private loadResignEmployees = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.employeeController + "/GetResignEmployeeCount");
        const data = httpPostHandleResponse(response);

        if (data) {
            let xAxis = [],
                yAxisHris = [],
                yAxisPayroll = [],
                iData = 0,
                lData = data.length,
                chartData = [];

            for (iData; iData < lData; iData++) {
                if (xAxis.indexOf(data[iData].MonthFormatted) == -1) {
                    xAxis.push(data[iData].MonthFormatted);
                }

                if (data[iData].Type == 'HRIS') {
                    yAxisHris.push(data[iData].Count);
                }

                if (data[iData].Type == 'Payroll') {
                    yAxisPayroll.push(data[iData].Count);
                }
            };

            chartData.push({ name: 'HRIS', data: yAxisHris });
            chartData.push({ name: 'Payroll', data: yAxisPayroll });

            this.loader.hideLoader();
            $('#divResigns').removeClass('d-none');

            Highcharts.chart('divResigns', {
                chart: {
                    type: 'spline'
                },
                title: {
                    text: ''
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    categories: xAxis
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: function () {
                            return (this.value / 1000) + 'k';
                        }
                    }
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            format: '{}{point.y}'
                        },
                        cursor: 'pointer',
                        events: {
                            click: (event: any) => {
                                const typeName = event.point.category;

                                this.drillBreadCrumb = [];

                                this.drillBreadCrumb[0] = {
                                    type: typeName,
                                    typePropName: 'typeid',
                                    name: event.point.series.name + ' - ' + event.point.category,
                                    className: 'drillResignEmployeeCountByClient',
                                    isDrillDownEnable: false
                                };

                                const date = new Date(typeName);

                                this.LoadResignEmployeeCountByClient(date.getMonth() + 1, date.getFullYear(), event.point.series.name);
                            }
                        }
                    }
                },
                series: [{
                    name: 'HRIS',
                    data: yAxisHris
                }, {
                    name: 'Payroll',
                    data: yAxisPayroll
                }]
            });
        }
    }

    private LoadResignEmployeeCountByClient = async (month: any, year: any, type: any) => {
        this.loader.showLoader();
        GetToken();

        let dataToSend = {
            Month: month, Year: year,
            Type: this.drillBreadCrumb[0].name.split('-')[0].trim()
        };

        const response = await http.post(this.constants.employeeController + "/GetResignEmployeeCountByClient", dataToSend);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Resign ' + this.drillBreadCrumb[0].name + ' by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-monthid="' + month + '" data-yearid="' + year + '" data-clientid="' + full.ClientId + '"><a href="javascript:;" class="btn btn-clean gridViewResignEmployeeByClientContextMenu" title="View Employees">' + data + '</a></div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private GetResignEmployeesByClient = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            month: number = actions.data('monthid'),
            year: number = actions.data('yearid'),
            clientId: number = actions.data('clientid');

        const request: any = {
            ClientId: clientId,
            Month: month,
            Year: year,
            Type: this.drillBreadCrumb[0].name.split('-')[0].trim()
        }

        this.drillBreadCrumb[0].isDrillDownEnable = true;

        this.drillBreadCrumb[1] = {
            type: formatDate_MMMYYYY(new Date(year + '-' + month + '-1')),
            typePropName: 'typeid',
            client: clientId,
            clientPrpName: 'clientid',
            name: actions.closest('tr').children('td:first').text(),
            className: 'gridViewEmpListContextMenu',
            isDrillDownEnable: false
        };

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.employeeController + "/GetResignEmployeesByClient/", request);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Department", "Employee", "Reports"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Dept' },
            { data: 'Employee' },
            { data: 'Employee', width: '300px' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'New Hire ' + this.drillBreadCrumb[0].name + ' - ' + this.drillBreadCrumb[1].name + ' Employees',
                        exportOptions: {
                            columns: [0, 1]
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        targets: 1,
                        className: 'dt-left',
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;" class="btn btn-clean gridViewProfileContextMenu" title="View Employee\'s Profile">' + data + '</a>'
                                + '</div>';
                        }
                    }, {
                        targets: 2,
                        className: 'dt-left',

                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewPayslipContextMenu" title="View Employee\'s Payslip">Payslip</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewLeaveQuotaContextMenu" title="View Employee\'s Leave Quota">Leave Quota</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewAttendanceContextMenu" title="View Employee\'s Attendance">Attendance</a>'
                                + '</div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }

    private ResignEmployeeBreadcrumMonthClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        const date = new Date($(event.currentTarget).closest('div.cust-actions').data('typeid'));

        this.LoadResignEmployeeCountByClient(date.getMonth() + 1, date.getFullYear(), this.drillBreadCrumb[0].name.split('-')[0].trim());
    }

    private loadLeaveRequest = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.leaveController + "/GetPendingLeaveApplications");
        const data = httpPostHandleResponse(response);

        if (data || data === 0) {
            $('#div_LeaveRequestCounter').removeClass('d-none');
            $('#div_LeaveRequestCounter #LeaveRequestCounter').html(data);

            $('#div_LeaveRequestCounter').on('click', this.loadLeaveRequestByClient);
        }
        this.loader.hideLoader()
    }

    private loadLeaveRequestByClient = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.leaveController + "/GetPendingLeaveApplicationsByClient");
        const data = httpPostHandleResponse(response);

        const typeName = "Leave Request";

        this.drillBreadCrumb = [];

        this.drillBreadCrumb[0] = {
            type: typeName,
            typePropName: 'typeid',
            name: typeName,
            className: 'drillLeaveRequestCountByClient',
            isDrillDownEnable: false
        };

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Leave Requests by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-clientid="' + full.ClientId + '"><a href="javascript:;" class="btn btn-clean gridViewLeaveRequestByClientContextMenu" title="View Employees">' + data + '</a></div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private GetLeaveRequestByClient = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            clientId: number = actions.data('clientid');


        this.drillBreadCrumb[0].isDrillDownEnable = true;

        this.drillBreadCrumb[1] = {
            type: '',
            typePropName: 'typeid',
            client: clientId,
            clientPrpName: 'clientid',
            name: actions.closest('tr').children('td:first').text(),
            className: 'gridViewEmpListContextMenu',
            isDrillDownEnable: false
        };

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.leaveController + "/GetPendingLeaveApplicationsByEmployees/" + clientId);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Department", "Employee", "Count", "Reports"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Dept' },
            { data: 'Employee' },
            { data: 'Count' },
            { data: 'Employee', width: '300px' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Leave Request - ' + this.drillBreadCrumb[1].name + ' Employees',
                        exportOptions: {
                            columns: [0, 1]
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        targets: 1,
                        className: 'dt-left',
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;" class="btn btn-clean gridViewProfileContextMenu" title="View Employee\'s Profile">' + data + '</a>'
                                + '</div>';
                        }
                    }, {
                        targets: 3,
                        className: 'dt-left',

                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewPayslipContextMenu" title="View Employee\'s Payslip">Payslip</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewLeaveQuotaContextMenu" title="View Employee\'s Leave Quota">Leave Quota</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewAttendanceContextMenu" title="View Employee\'s Attendance">Attendance</a>'
                                + '</div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }

    private LeaveRequestBreadcrumMonthClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        this.loadLeaveRequestByClient();
    }

    private loadResignRequest = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.resignController + "/GetPendingResignApplications");
        const data = httpPostHandleResponse(response);

        if (data || data === 0) {
            $('#div_ResignRequestCounter').removeClass('d-none');
            $('#div_ResignRequestCounter #ResignRequestCounter').html(data);

            $('#div_ResignRequestCounter').on('click', this.loadResignRequestByClient);
        }
    }

    private loadResignRequestByClient = async () => {
        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.resignController + "/GetPendingResignApplicationsByClient");
        const data = httpPostHandleResponse(response);

        const typeName = "Resign Request";

        this.drillBreadCrumb = [];

        this.drillBreadCrumb[0] = {
            type: typeName,
            typePropName: 'typeid',
            name: typeName,
            className: 'drillResignRequestCountByClient',
            isDrillDownEnable: false
        };

        const headers: any = ["Client", "Count"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Client' },
            { data: 'Count' }
        ]
            , settings: DataTables.Settings = {
                //dom: 'lBfrtip',
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Resign Requests by Client'
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        className: 'dt-left',
                        targets: 1,
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-clientid="' + full.ClientId + '"><a href="javascript:;" class="btn btn-clean gridViewResignRequestByClientContextMenu" title="View Employees">' + data + '</a></div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.generateModalBreadCrumb();

        this.$kt_Dashboard_Modal.modal('show');

        this.loader.hideLoader();
    }

    private ResignRequestBreadcrumMonthClick = async (event: JQueryEventObject) => {
        this.drillBreadCrumb[0].isDrillDownEnable = false;
        this.drillBreadCrumb = [this.drillBreadCrumb[0]];

        this.loadResignRequestByClient();
    }

    private GetResignRequestByClient = async (event: JQueryEventObject) => {

        const actions: any = $(event.currentTarget).closest('div.cust-actions'),
            clientId: number = actions.data('clientid');


        this.drillBreadCrumb[0].isDrillDownEnable = true;

        this.drillBreadCrumb[1] = {
            type: '',
            typePropName: 'typeid',
            client: clientId,
            clientPrpName: 'clientid',
            name: actions.closest('tr').children('td:first').text(),
            className: 'gridViewEmpListContextMenu',
            isDrillDownEnable: false
        };

        this.generateModalBreadCrumb();

        this.loader.showLoader();
        GetToken();

        const response = await http.post(this.constants.resignController + "/GetPendingResignApplicationsByEmployees/" + clientId);
        const data = httpPostHandleResponse(response);

        const headers: any = ["Department", "Employee", "Reports"];
        const headersHtml = getHtml_HandleBar(this.constants.gridHeaderTemplate, { data: headers });

        if (this.$grid) {
            this.$grid.destroy();
        }

        $(this.constants.gridDetails).empty().html(headersHtml);

        const columns: any[] = [
            { data: 'Dept' },
            { data: 'Employee' },
            { data: 'Employee', width: '300px' }
        ]
            , settings: DataTables.Settings = {
                dom: `<'row'<'col-sm-4 text-left'l><'col-sm-4 text-center'B><'col-sm-4 text-right'f>>
			<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'p>>`,
                buttons: [
                    {
                        extend: 'excel',
                        text: 'Export',
                        title: 'Resign Request - ' + this.drillBreadCrumb[1].name + ' Employees',
                        exportOptions: {
                            columns: [0, 1]
                        }
                    }
                ],
                order: [[0, 'asc']],
                responsive: true,
                lengthMenu: [[8, 25, 50, 100, -1], [8, 25, 50, 100, 'ALL']],
                pageLength: 8,
                searchDelay: 500,
                processing: false,
                serverSide: false,
                data: data,
                columns: columns,
                columnDefs: [
                    {
                        targets: 0,
                        className: 'dt-left'
                    },
                    {
                        targets: 1,
                        className: 'dt-left',
                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;" class="btn btn-clean gridViewProfileContextMenu" title="View Employee\'s Profile">' + data + '</a>'
                                + '</div>';
                        }
                    }, {
                        targets: 2,
                        className: 'dt-left',

                        render: function (data: any, a: any, full: any) {
                            return '<div class="cust-actions" data-id="' + full.LoginUserId + '">'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewPayslipContextMenu" title="View Employee\'s Payslip">Payslip</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewLeaveQuotaContextMenu" title="View Employee\'s Leave Quota">Leave Quota</a>'
                                + '<a href="javascript:;" style="text-align:left;font-size:.8rem;" class="btn btn-clean gridViewAttendanceContextMenu" title="View Employee\'s Attendance">Attendance</a>'
                                + '</div>';
                        }
                    }
                ]
            };

        this.$grid = $(this.constants.gridDetails).DataTable(settings);

        this.loader.hideLoader();
    }
}




$(() => new Dashboard());